<template>
    <section class="checkout-section">
        <div class="section-header">
            <h2>{{ resources.titleLabel }}</h2>
        </div>

        <span class="section-row-header">
            {{ resources.numberOfProducts }}
            <a v-if="!disableEditMode" @click="editCart" :title="resources.editLabel" class="section-link">
                {{ resources.editLabel }}
            </a>
        </span>

        <cart-line-items :items="lineItems.cartLineItems" />
        <cart-line-items v-if="lineItems.cartGiftWrapLineItems.length" :items="lineItems.cartGiftWrapLineItems" />

        <div class="section-row-wrapper-desktop" v-if="lineItems.cartFreeBonusProducts.length">
            <cart-line-items :items="lineItems.cartFreeBonusProducts" :isGift='false' />
        </div>
    
        <div class="section-row-wrapper-desktop" v-if="lineItems.cartGiftLineItems.length">
            <span class="section-row-header">{{ resources.giftSubtitleLabel }}</span>
            <cart-line-items :items="lineItems.cartGiftLineItems" :isGift='true' />
        </div>

        <div class="section-row-wrapper-desktop" v-if="lineItems.cartDiscountItems.length">
            <cart-line-items :items="lineItems.cartDiscountItems" :isRefill='true' :isGift='true' />
        </div>

        <div class="cost-details">
            <div class="cost-detail-row">
                <span>{{ resources.subtotalLabel }}</span>
                <span>{{ orderSubtotal }}</span>
            </div>
            <div v-if="promotions">
                <div v-for="promotion in promotions" :key="promotion.name">
                    <div class="cost-detail-row">
                        <span>{{ promotion.name}}</span>
                        <span>{{ promotion.discount }}</span>
                    </div>
                </div>
            </div>
            <div class="cost-detail-row" v-if="giftCardDeductionAmountValue > 0">
                <span>{{ resources.giftCardsLabel }}</span>
                <span>{{ giftCardDeductionAmount }}</span>
            </div>
            <div class="cost-detail-row" v-if="giftWrapAndGreetCardPriceValue > 0">
                <span>{{ resources.giftWrapAndGreetCardLabel }}</span>
                <span>{{ giftWrapAndGreetCardPrice }}</span>
            </div>
            <div class="cost-detail-row">
                <span>{{ resources.deliveryLabel }}</span>
                <span>{{ shippingPrice }}</span>
            </div>
            <div class="cost-detail-row">
                <span>
                    {{ resources.totalLabel }}
                    <span class="taxes-included">{{ resources.taxesLabel }}</span>
                </span>
                <span>{{ orderTotalsPrice }}</span>
            </div>
        </div>
        <div class="btn--checkout">
            <send-checkout-link-button/>
        </div>
    </section>
</template>

<script src='./order-overview.js'></script>
